import React, { useState } from 'react';
import { Stack, Typography, Grid, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { AppColors } from '../../../Utils/helper/AppColors';
import MentionProgress from '../../Reporting/Components/MentionProgress';
import { ExpandIcon } from '../../../Components/Icons/Icons';
import DataNotFound from '../../../Components/DataNotFound';
import { getColorSettings } from '../../../Utils/helper/commonUtils';

export default function CampaignDetailsInsights({ insights }) {
	console.log('insights', insights);
	const [selectedInsight, setSelectedInsight] = useState(insights[0]); // Default to the first insight

	const localSettingColors = getColorSettings();

	return (
		<Box
			sx={{
				borderRadius: '0 0 12px 12px',
				height: 'calc(100vh - 140px)',
				overflowY: 'auto',
				backgroundColor: AppColors.WHITE,
				px: '1.5px',
				py: '8px',
			}}
		>
			{insights?.length > 0 ? (
				<Grid container spacing={{ sm: 10, md: 1 }}>
					{/* Left Column: List of Insights */}
					<Grid
						item
						xs={12}
						sm={12}
						md={3.5}
						sx={{
							height: 'calc(100vh - 160px)',
							overflowY: 'auto',
						}}
					>
						<Stack gap={1}>
							{insights?.map((insight, index) => (
								<Stack
									key={index}
									direction="column"
									justifyContent="space-between"
									alignItems="flex-start"
									py={'12px'}
									px={'15px'}
									gap={'10px'}
									height={'80px'}
									sx={theme => ({
										backgroundColor: selectedInsight?.name === insight?.name ? theme.palette.primary.lightest_shade : AppColors.WHITE,
										borderRadius: '15px',
										border: `1px solid ${
											selectedInsight?.name === insight?.name ? theme.palette.primary.lighter_shade : AppColors.BORDER_SECONDARY
										}`,
										cursor: 'pointer',
										// width: '100%',
										'&:hover': { backgroundColor: theme.palette.primary.lightest_shade },
									})}
									onClick={() => setSelectedInsight(insight)} // Set selected insight
								>
									{/* Name and icon */}
									<Stack
										direction="row"
										justifyContent="space-between"
										sx={{ width: '100%' }} // Added width 100% to ensure proper alignment
									>
										<Typography
											textTransform="capitalize"
											sx={(theme) => ({
												color:
													selectedInsight?.name === insight?.name
														? theme.palette.primary.darker_primary
														: AppColors.HEADING_TITLE,
											})}
											fontFamily={'Poppins'}
											fontSize={14}
											fontWeight={600}
											lineHeight={'150%'}
											letterSpacing={'0%'}
										>
											{insight.name}
										</Typography>

										<Stack direction="row" ml={'auto'}>
											<ExpandIcon height={19} width={19} color={localSettingColors.fontColor} />
										</Stack>
									</Stack>

									{/* Report Tag */}
									<Stack
										direction="row"
										alignItems="center"
										justifyContent="center"
										sx={(theme) => ({
											backgroundColor: selectedInsight?.name === insight?.name ? AppColors.WHITE : theme.palette.primary.lightest_shade,
											color:
												selectedInsight?.name === insight?.name ? theme.palette.primary.lightest_shade : theme.palette.primary.darker_primary,
											borderRadius: '30px',
											border: `1px solid ${AppColors.BORDER_TERTIARY}`,

											px: 2,
											py: 0.5,
										})}
									>
										<Typography fontSize={10} fontWeight={400} fontFamily={'Poppins'} lineHeight={'121%'}>
											Reports: {insight?.reportedBy || 0}
										</Typography>
									</Stack>
								</Stack>
							))}
						</Stack>
					</Grid>

					{/* Right Column: Details of Selected Insight */}
					<Grid item xs={12} sm={12} md={8.5}>
						{selectedInsight ? (
							<Stack gap={2}>
								{/* Insight Name */}
								<Stack
									direction="column"
									gap={2}
									p={2}
									sx={theme => ({
										backgroundColor: AppColors.WHITE,
										borderRadius: 2,
										border: `1px solid ${theme.palette.primary.lighter_shade}`,
										boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',

										height: 'calc(100vh - 160px)',
										overflowY: 'auto',
									})}
								>
									<Stack direction="row" justifyContent="space-between">
										<Typography
											textTransform="capitalize"
											fontFamily={'Poppins'}
											fontSize={18}
											fontWeight={600}
											lineHeight={'150%'}
											color={AppColors.HEADING_TITLE}
										>
											{selectedInsight.name}
										</Typography>

										{/* Report Tag need cheage in tag fucture */}
										<Stack
											direction="row"
											alignItems="center"
											justifyContent="flex-start"
											sx={theme => ({
												backgroundColor: theme.palette.primary.lightest_shade,
												color: theme.palette.primary.darker_primary,
												borderRadius: '30px',
												border: `1px solid ${theme.palette.primary.lighter_shade}`,
												px: 2,
												py: 0.5,
												width: 'fit-content',
											})}
										>
											<Typography
												fontWeight={400}
												fontFamily={'Poppins'}
												lineHeight={'121%'}
												fontSize={10}
												sx={(theme) => ({
													color: theme.palette.primary.darker_primary,
												})}
											>
												Reports: {selectedInsight.reportedBy || 0}
											</Typography>
										</Stack>
									</Stack>

									{/* Subtopics */}
									{selectedInsight?.subTopic?.map((sub, subIndex) => (
										<Stack
											key={subIndex}
											direction="column"
											gap={1}
											sx={theme => ({
												backgroundColor: AppColors.WHITE,
												borderRadius: '10px',
												border: `1px solid ${theme.palette.primary.light_shade}`,
											})}
										>
											{/* Subtopic Name */}
											<Typography
												textTransform="capitalize"
												fontWeight={600}
												fontFamily={'Poppins'}
												lineHeight={'150%'}
												fontSize={16}
												sx={theme => ({
													padding: '8px 16px',
													borderBottom: `1px solid ${theme.palette.primary.light_shade}`,
												})}
											>
												{sub?.name}
											</Typography>

											{/* Mentions Table */}
											<TableContainer sx={{ border: 'none' }}>
												<Table sx={{ width: '96%', margin: '0 auto' }}>
													<TableHead
														sx={{
															'& .MuiTableCell-root': {
																fontSize: 12,
																color: AppColors.TEXT_TERTIARY,
																fontWeight: 500,
																fontFamily: 'Poppins',
															},
														}}
													>
														<TableRow>
															<TableCell width={'40%'}>Insights</TableCell>
															<TableCell width={'40%'}>Recommended Action</TableCell>
															<TableCell>Mentions</TableCell>
														</TableRow>
													</TableHead>
													<TableBody>
														{sub?.mentions?.map((mention, mentionIndex) => (
															<TableRow key={mentionIndex}>
																<TableCell>
																	<Typography
																		fontSize={12}
																		fontWeight={400}
																		fontFamily={'Poppins'}
																		lineHeight={'150%'}
																		color={AppColors.TEXT_PRIMARY}
																	>
																		{mention?.text}
																	</Typography>
																</TableCell>
																<TableCell>
																	<Typography
																		fontSize={12}
																		fontWeight={400}
																		fontFamily={'Poppins'}
																		lineHeight={'150%'}
																		color={AppColors.TEXT_PRIMARY}
																	>
																		{mention?.solution || 'N/A'}
																	</Typography>
																</TableCell>
																<TableCell>
																	<MentionProgress value={parseInt(mention?.reported?.replace('%', '') || 0)} />
																</TableCell>
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										</Stack>
									))}
								</Stack>
							</Stack>
						) : (
							<Stack alignItems="center" justifyContent="center" height="100%">
								<Typography variant="h6" color={AppColors.TEXT_SECONDARY}>
									{/* Select an insight to view details */}
								</Typography>
							</Stack>
						)}
					</Grid>
				</Grid>
			) : (
				<DataNotFound />
			)}
		</Box>
	);
}
